import styled from 'styled-components';
import Colors from 'pubweb-smokey/dist/colors';
import {
  desktop_breakpoint,
  desktop_breakpoint_extended,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';

const FeatureLayoutStyles = styled.div`
  .cta-inside {
    p {
      color: ${Colors.primary.white.standard};
    }
  }

  /* Add spacing between text above and button for all views */
  .cta-buttons {
    margin-top: 25px;
  }

  .cta-container {
    margin: 0 auto 30px;

    .cta-div {
      > div {
        height: 100%;
        min-height: 260px;
        border-radius: 4px;
        box-shadow: inset 0 0 0 1000px rgb(0 0 0 / 25%);
      }

      /* override some things in the CTA component */
      .custom-category,
      .tag {
        font-size: 10px;
        line-height: 12px;
      }
      .cta-inside {
        padding: 5px;
        .cta-heading {
          text-shadow: 0 0 3px rgb(37, 37, 37); //top of page CTAs
        }
      }
      a:link,
      a:visited,
      a:hover,
      a:active {
        color: ${Colors.primary.white.standard};
        text-decoration: none;
      }
    }
    .cta-three-container,
    .cta-two-container {
      display: grid;
      grid-gap: 20px;
    }
    .cta-grid-container {
      /* override some things in the CTA component */
      .cta-heading {
        /* settings for h3 font in smokey */
        font-size: 25px;
        line-height: 1.2;
        letter-spacing: -0.35px;
      }
    }
  }

  @media screen and (min-width: ${desktop_breakpoint}px) {
    .cta-container {
      .cta-position-fullwidth {
        > div {
          /* the CTA component sets a max width that needs to be undone */
          max-width: none;
          width: 100%;
        }
        .cta-text {
          max-width: 35%;
        }
        .cta-inside {
          padding-top: 70px;
        }
      }
    }
  }

  @media screen and (min-width: ${desktop_breakpoint_extended}px) {
    .cta-container {
      .cta-position-fullwidth {
        /* override some things in the CTA component */
        .cta-heading {
          font-size: 40px;
        }
      }
      .cta-div {
        > div {
          height: 100%;
          min-height: 260px;
        }
      }
      .cta-three-container {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr 1fr;
        grid-gap: 20px;
        .left {
          grid-column: 1;
          grid-row: 1 / 3;

          /* override some things in the CTA component */
          .cta-heading {
            max-width: 80%;

            /* settings for h2 font in smokey */
            font-size: 32px;
            line-height: 1.19;
            letter-spacing: -0.35px;
          }
        }
        .right-a {
          grid-column: 2;
          grid-row: 1;
        }
        .right-b {
          grid-column: 2;
          grid-row: 2;
        }
        .right-a,
        .right-b {
          /* override some things in the CTA component */
          .cta-heading {
            /* settings for h3 font in smokey */
            font-size: 25px;
            line-height: 1.2;
            letter-spacing: -0.35px;
          }
        }
      }
      .cta-two-container {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 20px;
        .left {
          grid-column: 1;
        }
        .right {
          grid-column: 2;
        }
        .left,
        .right {
          /* override some things in the CTA component */
          .cta-heading {
            /* settings for h3 font in smokey */
            font-size: 25px;
            line-height: 1.2;
            letter-spacing: -0.35px;
          }
        }
      }
    }
  }
`;

export default FeatureLayoutStyles;
